import { mapActions, mapGetters } from "vuex";

export const ligneRobMixin = {
  computed: {
    ...mapGetters({
      ligneRobsIsLoading: "ligneRob/list/isLoading",
      ligneRobUpdateIsLoading: "ligneRob/update/isLoading",
      ligneRobStructureIsLoading: "ligneRob/listStruct/isLoading",
      ligneRobs: "ligneRob/list/items",
      ligneStructs: "ligneRob/listStruct/items",
    }),
  },
  methods: {
    ...mapActions({
      getligneStructs: "ligneRob/listStruct/getItems",
      getligneRobs: "ligneRob/list/getItems",
      updateLigneRob: "ligneRob/update/updateLigneRob",
    }),
  },
};
